import { merge } from 'lodash';
// Direct imports of locale files
import en from './en.json';
import fr from './fr.json';
import { LocaleMessageDictionary } from 'vue-i18n';

export const LOCALES: string[] = ['en', 'fr'];

// Update interface to support nested objects
interface LocaleMessages {
    [locale: string]: Record<string, LocaleMessageDictionary<unknown, unknown>>;
}

export function loadLocaleMessages(): LocaleMessages {
    const messages: LocaleMessages = {
        en,
        fr,
    };

    const moduleNames: string[] = ['units', 'devices', 'erp'];

    // Try to load shared locales
    for (const locale of LOCALES) {
        for (const moduleName of moduleNames) {
            try {
                // eslint-disable-next-line @typescript-eslint/no-var-requires
                const moduleTranslations = require(`../aquassist-shared/i18n/${locale}/${moduleName}.json`);
                merge(messages[locale], moduleTranslations);
            } catch (error) {
                console.warn(`Could not load shared locale file for ${locale}/${moduleName}. `);
            }
        }
    }

    return messages;
}
